module.exports = __webpack_public_path__ + "img/dqd.58530899.png";